import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

function GridLayout3(props) {
  const { children, className } = props;

  return (
    <div
      className={cx(
        "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6",
        className
      )}
    >
      {children}
    </div>
  );
}

GridLayout3.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

GridLayout3.defaultProps = {
  className: "",
};

export default GridLayout3;
